    <div class="flex">
        <div class="order-view-header-font">Order ID: {{order.Id}}</div>
        <div class="status-badge ml-3 mt-1" [ngStyle]="order.StatusStyle">{{order.Status}}</div>
        <button mat-icon-button class="close-cross" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="line mt-7"></div>
    <mat-dialog-content class="mt-2">
        <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-align-tabs="start" class="tab-group pt-3 pb-3" animationDuration="0ms">
            <mat-tab label="Order Details">
                <ng-template matTabContent>
                    <div class="column-header-font mt-4 ml-3">Xpress Transaction</div>
                    <div class="flex">
                        <div class="ml-4 w-270 order-field order-field-name">
                            <div class="mt-3">Order Date:</div>
                            <div class="mt-3">Order Time:</div>
                            <div class="mt-3">Order Type:</div>
                            <div class="mt-3">Promo:</div>
                            <div class="mt-3">Promo Funded:</div>
                        </div>
                        <div class="w-270 order-field order-field-value">
                            <div class="mt-3">{{orderTransactionDate}}</div>
                            <div class="mt-3">{{orderTransactionTime}}</div>
                            <div class="mt-3">{{order.OrderType}}</div>
                            <div class="mt-3">{{order.Promo}}</div>
                            <div class="mt-3">{{order.PromoFunded}}</div>
                        </div>
                        <div class="w-270 order-field order-field-name">
                            <div class="mt-3">Payment Method:</div>
                            <div class="mt-3">Order Amount:</div>
                            <div class="mt-3">Deductions:</div>
                            <div class="mt-3">Paid Amount:</div>
                        </div>
                        <div class="w-270 order-field order-field-value">
                            <div class="mt-3">{{order.PaymentMethod}}</div>
                            <div class="mt-3">{{order.OrderAmount}}</div>
                            <div class="mt-3">{{order.Deductions}}</div>
                            <div class="mt-3">{{order.PaidAmount}}</div>
                        </div>
                    </div>

                    <hr>
                    <div class="column-header-font mt-4 ml-3">Delivery Details</div>
                    <div class="flex">
                        <div class="ml-4 w-270 order-field order-field-name">
                            <div class="mt-3">Delivery Type:</div>
                            <div class="mt-3">Delivery Created:</div>
                            <div class="mt-3">Delivery Date:</div>
                            <div class="mt-3">Delivery Time:</div>
                        </div>
                        <div class="w-270 order-field order-field-value">
                            <div class="mt-3">{{order.DeliveryType}}</div>
                            <div class="mt-3">{{orderStartTime}}</div>
                            <div class="mt-3">{{orderDate}}</div>
                            <div class="mt-3">{{orderEndTime}}</div>
                        </div>
                        <div class="w-270 order-field order-field-name">
                            <div class="mt-3">Delivery Partner:</div>
                            <div class="mt-3">Delivery Driver:</div>
                        </div>
                        <div class="w-270 order-field order-field-value">
                            <div class="mt-3">{{order.DeliveryPartner}}</div>
                            <div class="mt-3">{{order.DeliveryDriver}}</div>
                        </div>
                    </div>

                    <hr>
                    <div class="column-header-font mt-4 ml-3">Proof of delivery</div>
                    <div class="proof-of-delivery-badge mt-3 ml-3 cursor-pointer"
                         [ngClass]="{'btn-disabled': !order.ProofOfDelivery || order.ProofOfDelivery === '-'}" (click)="viewProof()">
                        Show Delivery Photo</div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Products">
                <ng-template matTabContent>
                    <div class="mt-4 mb-3 status-pill cursor-pointer">
                        <div [ngClass]="{'selected': isFulfilled, 'unselected': !isFulfilled}" (click)="swapTables('fulfilled')">Fulfilled: {{fulfilledCount}}</div>
                        <div [ngClass]="{'selected': !isFulfilled, 'unselected': isFulfilled}" (click)="swapTables('missing')">Missing Item: {{missingCount}}</div>
                    </div>
                    <p-table [columns]="productCols"
                             [value]="products"
                             [loading]="loading"
                             [paginator]="false"
                             [(first)]="first"
                             [rows]="rowsPerPage"
                             [rowsPerPageOptions]="rowsPerPageOptions"
                             [totalRecords]="totalRecords"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-striped'"
                             [style]="{height: 'calc(65vh)', marginTop: '20px'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="table-header-font" *ngFor="let col of productCols"
                                    pResizableColumn
                                    [style.width]="col.width">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <ng-container *ngFor="let col of productCols" >
                                    <td class="ui-resizable-column table-font"
                                        [style.width]="col.width">{{product[col.field]}}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="empty-table-container">
                                <img src="../Content/xpress-app/images/svg/no-orders-no-filter.svg" class="mb-3" />
                                <div class="empty-table-text fw-6">No products available</div>
                            </div>
                        </ng-template>
                    </p-table>
                    <div *ngIf="!isFulfilled && missingCount > 0" class="dispute-row">
                        <div class="dispute-container justify-content-between mt-3 mr-4">
                            <div class="dispute-block-text">
                                <div class="dispute-items-missing">{{missingCount}} Items Missing</div>
                                <div class="dispute-deducted">₱ {{deducted}} deducted from payout</div>
                            </div>
                            <button mat-button mat-flat-button color="primary" class="btn-font btn-print" (click)="openDisputeSidebar()">Dispute</button>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Payment">
                <ng-template matTabContent>
                    <p-table [columns]="paymentsCols"
                             [value]="payments"
                             [loading]="loading"
                             [paginator]="false"
                             [(first)]="first"
                             [rows]="rowsPerPage"
                             [rowsPerPageOptions]="rowsPerPageOptions"
                             [totalRecords]="totalRecords"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-striped'"
                             [style]="{height: 'calc(65vh)', marginTop: '20px'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="table-header-font" *ngFor="let col of paymentsCols"
                                    pResizableColumn
                                    [style.width]="col.width">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-payment>
                            <tr>
                                <ng-container *ngFor="let col of paymentsCols" >
                                    <td *ngIf="col.field === 'XpressStatus' || col.field === 'PartnerStatus'"
                                        class="ui-resizable-column table-font" [style.width]="col.width">
                                        <span class="status-badge" [ngStyle]="getStatusStyles(payment[col.field])">{{payment[col.field]}}</span>
                                    </td>
                                    <td *ngIf="col.field !== 'XpressStatus' && col.field !== 'PartnerStatus'"
                                        class="ui-resizable-column table-font" [style.width]="col.width">{{payment[col.field]}}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <div class="empty-table-container">
                                <img src="../Content/xpress-app/images/svg/no-orders-no-filter.svg" class="mb-3" />
                                <div class="empty-table-text fw-6">No payment records available</div>
                            </div>
                        </ng-template>
                    </p-table>
                </ng-template>
            </mat-tab>
            <mat-tab label="Messages">
                <ng-template matTabContent>
                    <div class="text-center messages-header-font mt-5">Store and Customer Messages</div>
                    <div class="text-center messages-chat-name mt-2">{{chatSubject}}</div>
                    <div class="messages-container mt-4">
                        <div *ngFor="let message of messages">
                            <div *ngIf="message.MessageTypeId === ChatMessageTypeEnum.CustomerToMerchant
                                || message.MessageTypeId === ChatMessageTypeEnum.SystemToMerchant">
                                <div class="mt-3 messages-chat-name">Customer</div>
                                <div class="mt-1 mb-1 customer-message-container">{{message.MessageText}}</div>
                                <div class="messages-chat-name">{{message.MessageTime}}</div>
                            </div>
                            <div *ngIf="message.MessageTypeId === ChatMessageTypeEnum.MerchantToCustomer
                                || message.MessageTypeId === ChatMessageTypeEnum.SystemToCustomer">
                                <div class="mt-3 messages-chat-name text-end">Store</div>
                                <div class="mt-1 mb-1 merchant-message-container">{{message.MessageText}}</div>
                                <div class="messages-chat-name text-end">{{message.MessageTime}}</div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Timeline">
                <ng-template matTabContent>
                    <div class="timeline-header-font mt-4 mb-4">Order Processing<span *ngIf="!timelineRows || !timelineRows.length"> - no timeline data available</span></div>
                    <div *ngFor="let timelineRow of timelineRows">
                        <div class="flex w-50 timeline-text mt-3 mb-3">
                            <div class="w-100">{{timelineRow.CheckpointName}}</div>
                            <div class="w-50">{{timelineRow.CheckpointTime}}</div>
                            <div class="w-100">{{timelineRow.CheckpointUser}}</div>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </mat-dialog-content>
    <div class="flex justify-content-end">
    <button mat-button mat-dialog-close class="btn-font btn-close mr-3" (click)="closeDialog()">Close</button>
    <button mat-button mat-flat-button color="primary" class="btn-font btn-print">Print</button>
    </div>

<p-toast key="modal" position="top-right"></p-toast>

<div class="spinner-container spinner-position" *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading...</p>
</div>
